import { 
    PROBE_STATE_GET_REQUEST, PROBE_STATE_GET_SUCCESS, PROBE_STATE_GET_ERROR, 
    PROBE_STATE_GET_BY_KEY_REQUEST, PROBE_STATE_GET_BY_KEY_SUCCESS, PROBE_STATE_GET_BY_KEY_ERROR, 
    PROBE_STATE_ADD_REQUEST, PROBE_STATE_ADD_SUCCESS, PROBE_STATE_ADD_ERROR, 
    PROBE_STATE_EDIT_REQUEST, PROBE_STATE_EDIT_SUCCESS, PROBE_STATE_EDIT_ERROR, 
    PROBE_STATE_DELETE_REQUEST, PROBE_STATE_DELETE_SUCCESS, PROBE_STATE_DELETE_ERROR
} from "../constants/probeStateConstants";

const initialState = {
    probeStates: [],
    probeState: {},
    loading: false,
    success: null,
    error: null,
    probeStateRequestedCount: 0,
};

export const probeStateReducer = (state = initialState, action) => {
    switch (action.type)     {
        case PROBE_STATE_GET_REQUEST:
            return {
                ...state,
                probeStateRequestedCount: ++state.probeStateRequestedCount,
                loading: true,
            };
        case PROBE_STATE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                probeStates: action.payload,
                success: true,
            };
        case PROBE_STATE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_STATE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_STATE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                probeState: action.payload,
                success: true,
            };
        case PROBE_STATE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_STATE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_STATE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROBE_STATE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_STATE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_STATE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROBE_STATE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_STATE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_STATE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROBE_STATE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
